/* The Elysian — Homepage JS
   Handles: hero carousel (autoplay + dots + arrows).
   The brand video section uses Shopify's native video_tag /
   external_video_tag, which already ship with their own player
   controls — no custom play-button JS needed there. */
(function () {
  "use strict";

  function initHero() {
    document.querySelectorAll(".hp-hero").forEach(function (hero) {
      var slides = hero.querySelectorAll(".hp-hero-slide");
      var dots = hero.querySelectorAll(".hp-hero-dots button");
      if (slides.length <= 1) return;

      var current = 0;
      var timer;

      function show(index) {
        slides[current].classList.remove("hp-active");
        if (dots[current]) dots[current].classList.remove("hp-active");
        current = (index + slides.length) % slides.length;
        slides[current].classList.add("hp-active");
        if (dots[current]) dots[current].classList.add("hp-active");
      }

      function next() { show(current + 1); }
      function prev() { show(current - 1); }
      function restart() {
        clearInterval(timer);
        timer = setInterval(next, 5000);
      }

      var nextBtn = hero.querySelector(".hp-hero-arrow.hp-next");
      var prevBtn = hero.querySelector(".hp-hero-arrow.hp-prev");
      if (nextBtn) nextBtn.addEventListener("click", function () { next(); restart(); });
      if (prevBtn) prevBtn.addEventListener("click", function () { prev(); restart(); });
      dots.forEach(function (dot, i) {
        dot.addEventListener("click", function () { show(i); restart(); });
      });

      restart();
    });
  }

  function initProductCarousels() {
    document.querySelectorAll("[data-hp-carousel]").forEach(function (track) {
      var wrap = track.closest(".hp-products-wrap");
      if (!wrap) return;
      var prevBtn = wrap.querySelector("[data-hp-carousel-prev]");
      var nextBtn = wrap.querySelector("[data-hp-carousel-next]");

      function scrollByCard(direction) {
        var card = track.querySelector(".hp-product-card");
        var amount = card ? card.getBoundingClientRect().width + 18 : 300;
        track.scrollBy({ left: amount * direction, behavior: "smooth" });
      }

      if (prevBtn) prevBtn.addEventListener("click", function () { scrollByCard(-1); });
      if (nextBtn) nextBtn.addEventListener("click", function () { scrollByCard(1); });
    });
  }

  function init() {
    initHero();
    initProductCarousels();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();